import { motion } from "framer-motion";

import { iconRegistry } from "@/content/iconRegistry";

export default function ChecklistSection({ content, sectionId, dataTestId }) {
  return (
    <section className="py-16 md:py-24 bg-muted/50" id={sectionId} data-testid={dataTestId}>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="font-sans text-3xl md:text-4xl font-bold text-foreground mb-8">{content.title}</h2>
            {content.description ? (
              <p className="font-body text-lg text-muted-foreground leading-relaxed mb-8">{content.description}</p>
            ) : null}
            <ul className="space-y-4">
              {content.items.map((item, index) => {
                const Icon = iconRegistry.CheckCircle;

                return (
                  <motion.li
                    key={item}
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.3, delay: index * 0.1 }}
                    className="flex items-start gap-3"
                  >
                    <Icon className="w-6 h-6 text-highlight mt-0.5 flex-shrink-0" />
                    <span className="font-body text-lg text-foreground/90">{item}</span>
                  </motion.li>
                );
              })}
            </ul>
          </motion.div>

          {content.visualCards?.length ? (
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="relative"
            >
              <div className="bg-card rounded-3xl p-8 shadow-soft border border-border">
                <div className="grid grid-cols-2 gap-4">
                  {content.visualCards.map((card) => {
                    const Icon = iconRegistry[card.icon];
                    const tone = card.tone === "soft" ? "bg-secondary/80 border border-white/10" : "bg-secondary/36 border border-secondary/45";
                    const iconTone = card.tone === "soft" ? "text-white" : "text-highlight";

                    return (
                      <div key={card.title} className={`${tone} rounded-2xl p-6 text-center`}>
                        <Icon className={`w-8 h-8 ${iconTone} mx-auto mb-2`} />
                        <p className="font-sans font-semibold text-foreground">{card.title}</p>
                      </div>
                    );
                  })}
                </div>
              </div>
            </motion.div>
          ) : null}
        </div>
      </div>
    </section>
  );
}
